export const handleConfig = (event) => {
  try {
    const data = typeof event.data === "string" ? JSON.parse(event.data) : event.data;
    if (data.type === "KIOSK_CONFIG") {
      console.log("Kiosk Config fetched :", data);

      // Store wrapper and kioskPath in localStorage
      if (data.wrapper) {
        localStorage.setItem("wrapper", data.wrapper);
        console.log("Wrapper set to:", data.wrapper);
      }
      if (data.restId) {
        localStorage.setItem("restaurantId", data.restId);
      }
    }
  } catch (err) {
    console.warn("Message parse error:", err);
  }
};

export const handleWrapperMessage = (event, { setIsWaitingForCard, setIsProcessing, onPaymentSuccess, onPaymentFailure, onClose, onAutoCancel }) => {
  try {
    const data = typeof event.data === 'string' ? JSON.parse(event.data) : event.data;
    console.log("Wrapper Message:", data);

    if (data.type === "PAYMENT_STATUS") {
      if (data.status === "waitingForInput") {
        setIsWaitingForCard(true);
        setIsProcessing(false);
      }
      if (data.status === "processing") {
        setIsProcessing(true);
        setIsWaitingForCard(false);
      }
    }

    if (data.type === 'PAYMENT_RESULT') {
      console.log("Wrapper Payment Result:", data);
      setIsProcessing(false);
      if (data.status === 'success') {
        onPaymentSuccess(data.paymentIntent);
        onClose();
      } else if (data.status === 'failed') {
        console.log("Wrapper Payment Result Error:", data.error.code);
        onPaymentFailure(new Error(data.error.code || 'Payment failed'));
      }
    }
    if (data.type === "PAYMENT_TIMEOUT") {
      if (data.message === "card_not_tapped") {
        onAutoCancel();
      }
    }

    if (data.type === "PAYMENT_PROCESS_FAILED") {
      onClose();
      onPaymentFailure(new Error(data.message || 'Payment process failed'));
    }
  } catch (err) {
    // console.warn("Message error:", err);
  }
};
